/** @deprecated kayCode is deprecated */
export const keyArrowUp = 38;
/** @deprecated kayCode is deprecated */
export const keyArrowDown = 40;
/** @deprecated kayCode is deprecated */
export const keyArrowRight = 39;
/** @deprecated kayCode is deprecated */
export const keyArrowLeft = 37;
/** @deprecated kayCode is deprecated */
export const keyPageUp = 33;
/** @deprecated kayCode is deprecated */
export const keyPageDown = 34;
/** @deprecated kayCode is deprecated */
export const keyHome = 36;
/** @deprecated kayCode is deprecated */
export const keyEnd = 35;
/** @deprecated kayCode is deprecated */
export const keyEnter = 13;
/** @deprecated kayCode is deprecated */
export const keySpace = 32;
/** @deprecated kayCode is deprecated */
export const keyTab = 9;
/** @deprecated kayCode is deprecated */
export const keyEscape = 27;
/** @deprecated kayCode is deprecated */
export const keyBackspace = 8;
/** @deprecated kayCode is deprecated */
export const keyDelete = 46;
/** @deprecated kayCode is deprecated */
export const keyShift = 16;
/** @deprecated kayCode is deprecated */
export const keyCtrl = 17;
/** @deprecated kayCode is deprecated */
export const keyAlt = 18;
